<template>
  <div class="print-order px-2 mx-0 pagebreak">
    <div
      class="top-part d-flex justify-content-between align-items-center p-2 mt-1"
    >
      <div
        class="w-100 d-flex flex-column justify-content-center align-items-center"
      >
        <figure class="feresteh-png">
          <img
            class="w-100"
            src="@/assets/images/feresteh.png"
            alt="feresteh"
          />
        </figure>
        <span>فرسته</span>
      </div>
      <div
        class="w-100 d-flex flex-column justify-content-center align-items-center"
      >
        <span class="font-weight-bold px-1">پیشخان مجازی پستی</span>
        <span>صدور کد رهگیری با جمع آوری از مبدا</span>
      </div>
      <div
        class="w-100 d-flex flex-column justify-content-center align-items-center"
      >
        <span class="font-weight-bold">نشانی اینترنتی:</span>
        <span>feresteh.ir</span>
      </div>
      <div
        class="w-100 d-flex flex-column justify-content-center align-items-center"
      >
        <span class="font-weight-bold">پشتیبانی فرسته:</span>
        <span>09919112213</span>
      </div>
      <div
        class="w-100 d-flex flex-column justify-content-center align-items-center"
      >
        <span class="font-weight-bold">شماره فاکتور:</span>
        <span>{{ order.id }}</span>
      </div>
    </div>
    <div
      class="second-box border-table d-flex justify-content-between p-2 align-items-center mt-1"
      v-if="order && order.id"
    >
      <div>
        <p class="m-0 d-flex gap-1 align-items-center">
          <b>فرستنده : </b>
          {{ settings.filter((item) => item.name == "shop_name")[0].value }}
        </p>
        <p class="m-0 d-flex gap-1 align-items-center">
          <span class="font-weight-bold fontsize15 mb-0">استان-شهر : </span>
          <span class="fontsize14">
            گلستان - گرگان
          </span>
        </p>
        <div class="d-flex gap-1 align-items-center">
          <span class="font-weight-bold fontsize15 mb-0">
            کدپستی :
          </span>
          <span class="mb-0 fontsize14">
            {{
              settings.filter((item) => item.name == "shop_postal_code")[0]
                .value
            }}
          </span>
        </div>
        <div class="d-flex gap-1 align-items-center">
          <span class="font-weight-bold fontsize15 mb-0">
            شماره تماس :
          </span>
          <span class="mb-0 fontsize14">
            {{
              settings.filter((item) => item.name == "shop_telephone")[0].value
            }}
          </span>
        </div>
        <div class="d-flex gap-1 align-items-center">
          <span class="font-weight-bold fontsize15 mb-0">
            نشانی :
          </span>
          <span class="mb-0 fontsize14" v-html="cloneGorgan(settings)"> </span>
        </div>
      </div>
      <figure class="logo-img">
        <img class="w-100" src="@/assets/images/logo.png" alt="logo" />
      </figure>
    </div>
    <p class="fontsize14 border-table w-100 p-1 d-flex justify-content-start">
      تمامی مسئولیت های مرتبط با محتوای سفارش اعم از مطابقت سفارش با درخواست
      مشتری و رعایت قوانین و مقرارات مربوطه بر عهده فروشگاه میباشد
    </p>
    <div class="border-table">
      <p class="m-0 d-flex justify-content-start">
        <b>گیرنده : </b>
        <span class="mb-0 pr-1 fontsize18 pl-1 font-weight-bolder">
          {{ address.city.province ? address.city.province.name : "" }}
          - {{ address.city ? address.city.name : "" }}
        </span>
        <span> - {{ address.address }} </span>
      </p>
      <div class=" d-flex">
        <span class="font-weight-bold fontsize15 mb-0">
          نام کامل :
          <span
            class="mb-0 pr-1 fontsize18 font-weight-bolder pl-2"
            style="font-weight: 500"
          >
            {{ address.first_name }} {{ address.last_name }}
          </span>
        </span>
      </div>
      <div class="d-flex">
        <span class="font-weight-bold fontsize15 mb-0">
          کدپستی:
        </span>
        <span class="mb-0 fontsize14 pl-2">
          {{ address.postal_code }}
        </span>
        <span class="font-weight-bold fontsize15 mb-0">
          تلفن:
        </span>
        <span class="mb-0 fontsize14 pl-2">
          {{ address.mobile }}
        </span>
        <span v-if="order">
          <span class="font-weight-bold fontsize15 mb-0">
            روش حمل و نقل:
          </span>
          <span class="mb-0 fontsize14 pl-2">
            {{
              order.is_shopino && order.shipping_title
                ? order.shipping_title
                : order.shipping
                ? order.shipping.name
                : ""
            }}
          </span>
        </span>
        <span v-if="invoice" class="print-order-invoice">
          <span class="font-weight-bold fontsize15 mb-0">
            روش پرداخت:
          </span>
          <span v-if="invoice.type == 'gateway'" class="mb-0 fontsize14 pl-2">
            درگاه
            {{ invoicePayment ? invoicePayment.gateway_label : "" }}
          </span>
          <span
            v-else-if="invoice.type == 'wallet'"
            class="mb-0 fontsize14 pl-2"
          >
            کیف پول
          </span>
        </span>
      </div>
      <p v-if="order.description" class="m-0">
        <span class="text-center fontsize15 font-weight-bolder">
          توضیحات :
        </span>

        <span
          class="print-order-item-info fontsize14 px-1 text-right"
          style="line-height:20px!important; display: inline-block;"
        >
          {{ order.description }}
        </span>
      </p>
    </div>

    <div class="bottom-part d-flex border-table mt-1">
      <div class="right-part border-left">
        <div class="d-flex flex-column border-b  p-1">
          <p class="fontsize15 mb-0 d-flex justify-content-start">
            خدمات تجارت الکترونیک شرکت ملی پست/پیشتاز
          </p>
          <div class="d-flex align-content-center gap-1 fontsize15">
            <span>کرایه پستی:</span>
            <b v-if="order.shipping_amount != 0">
              {{ (order.shipping_amount * 10) | price }} ریال
            </b>
            <b v-else class="">
              رایگان
            </b>
          </div>
          <p class="m-0 d-flex justify-content-start">
            (به صورت آنلاین پرداخت شده است)
          </p>
          <div
            v-if="order.post_tax"
            class="d-flex align-content-center gap-1 fontsize15"
          >
            <span>مالیات بر ارزش افزوده:</span>
            <b class="fontsize15"> {{ (order.post_tax * 10) | price }} ریال </b>
          </div>
        </div>
        <div class="d-flex justify-content-start flex-column border-b  p-1">
          <p class="fontsize15 mb-0 d-flex justify-content-start">
            علت برگشتی:
          </p>
          <div class="bragashti">
            <label for="" class="d-flex align-items-center">
              <input type="checkbox" class="" />
              <span class="px-1 fontsize15">نقل مکان</span>
            </label>
            <label for="" class="d-flex align-items-center">
              <input type="checkbox" class="" />
              <span class="px-1 fontsize15">عدم اطلاع از سفارش</span>
            </label>
            <label for="" class="d-flex align-items-center">
              <input type="checkbox" class="" />
              <span class="px-1 fontsize15">مغایرت مبلغ فاکتور</span>
            </label>
            <label for="" class="d-flex align-items-center">
              <input type="checkbox" class="" />
              <span class="px-1 fontsize15">عدم وجود وجه نقد/کارت</span>
            </label>
            <label for="" class="d-flex align-items-center">
              <input type="checkbox" class="" />
              <span class="px-1 fontsize15">گیرنده شناخته نشد</span>
            </label>
            <label for="" class="d-flex align-items-center">
              <input type="checkbox" class="" />
              <span class="px-1 fontsize15">سفارش تکراری</span>
            </label>
            <label for="" class="d-flex align-items-center">
              <input type="checkbox" class="" />
              <span class="px-1 fontsize15">درخواست بازگشایی</span>
            </label>
            <label for="" class="d-flex align-items-center">
              <input type="checkbox" class="" />
              <span class="px-1 fontsize15">تاخیر در ارسال سفارش</span>
            </label>
            <label for="" class="d-flex align-items-center">
              <input type="checkbox" class="" />
              <span class="px-1 fontsize15">انصراف از خرید</span>
            </label>
            <label for="" class="d-flex align-items-center">
              <input type="checkbox" class="" />
              <span class="px-1 fontsize15">سایر موارد...</span>
            </label>
          </div>
        </div>
        <div class="p-1">
          <p class="fontsize15 m-0 mb-2 d-flex justify-content-start">
            نام و نام خانوادگی نامه رسان:
          </p>
          <p class="fontsize15 m-0 d-flex justify-content-start">امضا:</p>
        </div>
      </div>
      <div class="left-part d-flex flex-column p-2">
        <div class="justify-content-center align-items-center d-flex">
          <div
            class="d-flex flex-column  align-items-center justify-content-center"
          >
            <span class="mb-2 fontsize14 border-table border-radius">
              گلستان - گرگان
            </span>
            <span class="mb-2 fontsize14 border-table border-radius">
              {{ address.city.province ? address.city.province.name : "" }}
              - {{ address.city ? address.city.name : "" }}
            </span>
            <span class="mb-2 fontsize14 border-table border-radius">
              {{ order.total_amount | price }} تومان
            </span>
          </div>
          <div
            class="px-5 d-flex flex-column justify-content-center align-items-center"
          >
            <figure
              class="feresteh-png d-flex flex-column justify-content-center align-items-center"
            >
              <img src="@/assets/images/feresteh2.jpeg" alt="feresteh" />
              <figcaption class="fontsize14">فرسته</figcaption>
            </figure>
            <div
              v-if="order.barcode"
              class="d-flex flex-column justify-content-center align-items-center"
            >
              <span class="mb-1 fontsize14">پیشخوان مجازی</span>
              <div class="qr-container">
                <img v-if="qr" :src="qr" alt="QR Code" />
              </div>
            </div>
          </div>
          <div
            class="d-flex flex-column  align-items-center justify-content-center"
          >
            <span class="mb-2 fontsize14 border-table border-radius">
              {{ moment(order.created_at).format("HH:mm YYYY/MM/DD") }}
            </span>
            <p class="m-0 fontsize14 border-table border-radius">
              <span class="mb-0 fontsize14 ">
                {{ order.weight ? Number(order.weight) + 200 : "" }}
              </span>
              <span class="mb-0  fontsize14 ">
                گرم
              </span>
            </p>
          </div>
        </div>
        <div
          v-if="order.barcode"
          class="barcode-content d-flex justify-content-center align-items-center"
        >
          <VueBarcode
            fontSize="14"
            width="2"
            marginBottom="0"
            height="35"
            :value="order.barcode"
            :text="order.barcode"
          >
            {{ order.barcode }}
          </VueBarcode>
        </div>
        <div class="d-flex gap-2 justify-content-center align-items-center">
          <span class="fontsize15 m-0">بارکد شیپ:</span>
          <span class="fontsize15 m-0">
            <span>{{ order.id }}</span>
          </span>
        </div>
      </div>
    </div>
    <div
      class="d-flex justify-content-center align-items-center p-2 border mt-0 mb-2"
    >
      <span class="font-weight-bold fontsize20 mb-0">
        مقصد:
      </span>
      <span class="font-weight-bold fontsize20 mb-0">
        {{ address.city.province ? address.city.province.name : "" }}
        - {{ address.city ? address.city.name : "" }}
      </span>
    </div>
    <b-table
      responsive
      :items="order.active_items"
      :fields="fields"
      class="table print-customer-order-table mb-1"
      :tbody-tr-class="rowClass"
    >
      <template v-slot:cell(index)="data">
        {{ data.index + 1 }}
      </template>
      <template v-slot:cell(sku)="data">
        <span>{{ data.item.variety.SKU || data.item.product.SKU }}</span>
      </template>
      <template v-slot:cell(product)="data">
        <p style="line-height:2" class="mb-0">
          {{ data.item.product.title }}
          <span
            v-if="data.item.extra.color || data.item.extra.attributes != ''"
            class="mr-1"
          >
          </span>
          <span v-if="data.item.extra.color != null">
            رنگ : {{ data.item.extra.color }}
            {{
              data.item.extra.color && data.item.extra.attributes != ""
                ? " | "
                : ""
            }}
          </span>
          <span v-if="data.item.extra.attributes != ''">
            <span
              v-for="(attr, index) in data.item.extra.attributes"
              :key="index"
            >
              {{ attr.label + ":" + attr.pivot.value }}
              {{ index != data.item.extra.attributes.length - 1 ? " | " : "" }}
            </span>
          </span>
        </p>
      </template>
      <template v-slot:cell(amount)="data">
        <span v-if="data.item.amount != 0"
          >{{ (data.item.amount + data.item.discount_amount) | price }}
        </span>
        <span v-else>0</span>
      </template>
      <template v-slot:cell(quantity)="data">
        <span style="font-weight: bold">{{ data.item.quantity }}</span>
      </template>
      <template v-slot:cell(discount_amount)="data">
        <span v-if="data.item.discount_amount">{{
          data.item.discount_amount | price
        }}</span>
        <span v-else>ندارد</span>
      </template>
      <template v-slot:cell(total_price)="data">
        <span v-if="data.item.amount != 0"
          >{{ (data.item.amount * data.item.quantity) | price }}
        </span>
        <span v-else>0</span>
      </template>
    </b-table>
    <div class="text-center print-order-btn mb-4">
      <button class="btn btn-print text-white" @click="orderPrint()">
        چاپ فاکتور
      </button>
    </div>
  </div>
</template>
<script>
import OrderPrintItemImpl from "@@/core/components/order/OrderPrintItem/OrderPrintItemImpl";
export default {
  extends: OrderPrintItemImpl,
};
</script>
<style
  scoped
  src="@@/core/components/order/OrderPrintItem/OrderPrintItemStyle.css"
>
#print button.btn.btn-print {
  background: #bf9b74 !important;
}
</style>
<style>
#print .print-customer-order-table tbody tr.highlight td {
  background-color: #ff000052 !important;
}
#print button.btn.btn-print {
  color: black !important;
}
tr.warnignRow {
  text-decoration: 3px line-through red;
}
</style>
